'use client';

import { useEffect } from 'react';
import { initSentry } from '@/lib/sentry';

/**
 * Client component to initialize Sentry on mount
 * This should be included once in the root layout
 */
export function SentryInit() {
  useEffect(() => {
    initSentry();
  }, []);

  return null;
}
